import { render } from "./TimeStats.vue?vue&type=template&id=a1c27418&scoped=true"
import script from "./TimeStats.vue?vue&type=script&lang=js"
export * from "./TimeStats.vue?vue&type=script&lang=js"

import "./TimeStats.vue?vue&type=style&index=0&id=a1c27418&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c27418"]])

export default __exports__